<template>
    <div class="notice_container">
        <div class="headIcon">
            <van-icon name="arrow-left" @click="goToHome" />
        </div>
        <img src="@/assets/themeFour/logo.png" alt="" /> 
        <p class="titleHead">{{$t('notice.updateNotification')}}</p>
        <div v-html="$t('notice.contentText')"></div>
    </div>
</template>

<script setup lang="ts">
const emits = defineEmits(['goToHome'])

const goToHome = () => {
    emits('goToHome')
}

</script>
<style scoped>
.notice_container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    color: rgba(255, 255, 255, .4);
    font-size: 14px;
}

.notice_container img {
    width: 50%;
    padding-bottom: 20px;
}

.headIcon {
    position: fixed;
    top: 20px;
    left: 20px;
    font-size: 25px;
}
.headIcon img{
    width: 50px;
}
.titleHead {
    color: #ffff;
    font-size: 18px;
    font-weight: bold;
}

.back-link {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px 0;
  font-family: inherit;
  color: #ffffff; 
  transition: color 0.2s;
}

.back-link:hover {
  color: #7485aa; 
}

.chevron {
  font-size: 1.2rem;
  line-height: 1;
  margin-bottom: 2px; 
}

.text {
  font-size: 1rem;
  font-weight: 500;
}

</style>